export class AppGlobalControlValues {
  public static readonly LOG_OUT_BUTTON: string = 'log-out-button';
}
